
import ProcessLineItemsMixin from "~/mixin/process-lineitems-mixin";
import ProductMapMixin from "~/mixin/product-map-mixin";
import DeliveryWeekMixin from "~/mixin/delivery-week-mixin";
import FormatMixin from "~/mixin/format-mixin";
import { butter } from "~/plugins/buttercms";
import "@fortawesome/fontawesome-free/css/all.css";
const datadogErrorUrl = "datadog/events/error";
import {
  invokeShopifyQuery,
  itemFilterWithActive,
  itemFilterWithGreets,
  itemfilterWithCharity,
  GIFT_ADDS,
  VASE,
  GREET_NAME,
  GREET,
} from "@/utils/shopify";

export default {
  name: "cal-vases-addons",
  mixins: [
    ProcessLineItemsMixin,
    ProductMapMixin,
    DeliveryWeekMixin,
    FormatMixin,
  ],
  data() {
    return {
      deliveryDate: "",
      deliveryTown: {},
      occasion: "",
      sku: "",
      showReadMore: false,
      readMoreAddon: {},
      maxTitleLength: 18,
      isVases: true,
      disableSection: true,
      addOnsCMS: [],
      addOns: [],
      vases: [],
      noVaseTag: false,
      noAddonsTag: false,
      selectedVaseUpdated: null,
      selectedAddonsUpdated: null,
      configs: {
        Flowers: {
          displayVases: true,
          displayAddons: true,
        },
        Bundle: {
          displayVases: false,
          displayAddons: true,
        },
        Subscription: {
          displayVases: true,
          displayAddons: true,
        },
        Curated_Bundle: {
          displayVases: false,
          displayAddons: true,
        },
      },
    };
  },
  async created() {
    this.deliveryDate =
      this.$store.state.cartItem.deliveryDate || sessionStorage.deliveryDate;
    this.deliveryTown =
      this.$store.state.cartItem.deliveryTown ||
      JSON.parse(sessionStorage.getItem("deliveryTown"));

    this.occasion =
      this.$store.state.cartItem.occasion || sessionStorage.occasion;
    if (this.$route.params["sku"]) {
      this.sku = this.$route.params["sku"];
    }

    this.$nuxt.$on("cityUpdated", async () => {
      this.deliveryTown =
        this.$store.state.cartItem.deliveryTown ||
        JSON.parse(sessionStorage.getItem("deliveryTown"));
      this.occasion =
        this.$store.state.cartItem.occasion || sessionStorage.occasion;
      this.checkInputsValid();
      await this.loadAddons();
    });

    this.$nuxt.$on("deliveryDateUpdated", async () => {
      this.deliveryDate =
        this.$store.state.cartItem.deliveryDate || sessionStorage.deliveryDate;
      this.checkInputsValid();
      await this.loadAddons();
    });

    this.$nuxt.$on("occasionSelected", async () => {
      this.occasion =
        this.$store.state.cartItem.occasion || sessionStorage.occasion;
      this.checkInputsValid();
      await this.loadAddons();
    });

    this.$nuxt.$on("productSelected", () => {
      this.checkIfNoVaseVariant();
    });
  },
  watch: {
    async product() {
      this.noVaseTag =
        this.product &&
        this.product.tags &&
        this.product.tags.includes("NoVase");
      this.noAddonsTag =
        this.product &&
        this.product.tags &&
        this.product.tags.includes("NoAddons");

      this.checkIfNoVaseVariant();

      this.deliveryTown =
        JSON.parse(sessionStorage.getItem("deliveryTown")) || {};
      this.deliveryDate = sessionStorage.deliveryDate || "";
      this.occasion = sessionStorage.occasion || "";
      this.checkInputsValid();
      await this.loadAddons();
      this.selectCorrectTab();
    },
    async occasion() {
      this.checkInputsValid();
      await this.loadAddons();
    },
    vases() {
      this.selectCorrectTab();
    },
  },
  computed: {
    selectedAddons() {
      return this.selectedAddonsUpdated || this.$store.state.cartItem.addons;
    },
    selectedVase() {
      return this.selectedVaseUpdated || [this.$store.state.cartItem.vase];
    },
    product() {
      return this.$store.state.cartItem.product;
    },
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
  },
  methods: {
    checkIfNoVaseVariant() {
      const regex = /[^a-zA-Z0-9]/g;
      const vasesDisplayTagWithSpaces =
        this.$store.state.cartItem.product?.title
          .trim()
          .replace(regex, " ")
          .toLowerCase();
      if(!vasesDisplayTagWithSpaces) {
        return;
      }
      const vasesDisplayTag = `${vasesDisplayTagWithSpaces.replace(
        /\s+/g,
        "-"
      )}-no-vase`;
      if (
        this.$store.state.cartItem.product?.tags &&
        this.$store.state.cartItem.product?.tags.includes(vasesDisplayTag)
      ) {
        this.noVaseTag = true;
      }
    },
    scrollLeft(refName) {
      const container = this.$refs[refName];
      if (container) {
        container.scrollLeft -= 100;
      }
    },
    scrollRight(refName) {
      const container = this.$refs[refName];
      if (container) {
        container.scrollLeft += 100;
      }
    },
    selectCorrectTab() {
      if (this.vases.length > 0 && this.addOns.length == 0) {
        this.isVases = true;
      } else if (this.vases.length == 0 && this.addOns.length > 0) {
        this.isVases = false;
      }

      if (this.noVaseTag) {
        this.isVases = false;
      } else if (this.noAddonsTag) {
        this.isVases = true;
      }
    },
    handleShowReadMore(addon) {
      this.readMoreAddon = addon;
      this.showReadMore = true;
    },
    isObjectNotEmpty(obj) {
      return Object.keys(obj).length > 0;
    },
    async getAddonsContent() {
      try {
        const response = await butter(this.$config).content.retrieve(
          ["addons"],
          {
            locale: this.$i18n.locale,
            "fields.type1": "common",
          }
        );
        this.addOnsCMS = this.mapCMSAddons(response);
      } catch (error) {
        console.error(error);
      }
    },
    generateOccasionTag(occasion) {
      let tag = occasion.trim().replace(/ /g, "-");
      return `occasion:${tag.toLowerCase()}`;
    },
    getOrderSequenceNumber(tags) {
      //TODO:: need refactor
      let seqNum = 100;
      if (tags.length > 0 && tags.includes("order-sequence")) {
        tags.forEach((tag) => {
          if (tag.includes("sequence-number")) {
            seqNum = parseInt(tag.split("-")[2]);
          }
        });
      }
      return seqNum;
    },
    getUserViewName(title, productType, cmsData) {
      const cmsProduct = cmsData.filter(
        (product) => product.productName == title
      )[0];
      return cmsProduct ? cmsProduct.displayName : "";
    },
    getUserViewDescription(title, productType, cmsData) {
      const cmsProduct = cmsData.filter(
        (product) => product.productName == title
      )[0];
      return cmsProduct ? cmsProduct.shortDescription : "";
    },
    showVases() {
      if (!this.disableSection) {
        this.isVases = true;
      }
    },
    showAddons() {
      if (!this.disableSection) {
        this.isVases = false;
      }
    },
    checkInputsValid() {
      let validInput = true;

      if (!(this.deliveryDate && this.deliveryDate.length > 0)) {
        validInput = false;
      }

      if (!(this.deliveryTown && Object.keys(this.deliveryTown).length > 0)) {
        validInput = false;
      }

      if (!(this.product && Object.keys(this.product).length > 0)) {
        validInput = false;
      }

      this.disableSection = !validInput;
    },
    getAddons(regionShortCode) {
      return (async () => {
        try {
          if (this.workflow == "NON_FLORAL") {
            const { data } = await invokeShopifyQuery(
              itemFilterWithActive("TR", GIFT_ADDS)
            );
            this.addOns = await this.processAddons(
              this.mapShopifyProducts(data),
              GIFT_ADDS
            );
          } else {
            const { data } = await invokeShopifyQuery(
              itemFilterWithActive(regionShortCode, GIFT_ADDS)
            );
            this.addOns = await this.processAddons(
              this.mapShopifyProducts(data),
              GIFT_ADDS
            );
          }

          // Remove the flower food addon from the addons when selected product include 'Everlasting' tag
          const cartItem = this.$store.state.cartItem;

          if (cartItem?.product?.tags?.includes("Everlasting")) {
            const addonIndex = this.addOns.findIndex((addon) =>
              addon.sku?.includes("flower-food")
            );
            if (addonIndex !== -1) {
              this.addOns.splice(addonIndex, 1);
            }
          }
        } catch (err) {
          console.error(err);
          await this.$axios.$post(
            datadogErrorUrl,
            {
              error: {
                name: "ADDONS-NOT-FOUND",
                ddSessionId: this.getatadogSessionID(),
              },
            },
            {}
          );
        }
      })();
    },
    getVases(regionShortCode) {
      return (async () => {
        try {
          const { data } = await invokeShopifyQuery(
            itemFilterWithActive(regionShortCode, VASE)
          );
          this.vases = await this.processVases(
            this.mapShopifyProducts(data),
            VASE
          );
          // Remove surprise me vase for grand variant
          if (
            this.sku === this.$store.state.cartItem.product?.sku &&
            this.$store.state.cartItem.product?.title === "Grand"
          ) {
            this.vases = this.vases.filter(
              (item) => item.title !== "Surprise Me"
            );
          }
        } catch (err) {
          console.error(err);
          await this.$axios.$post(
            datadogErrorUrl,
            {
              error: {
                name: "VASES-NOT-FOUND",
                ddSessionId: this.getatadogSessionID(),
              },
            },
            {}
          );
        }
      })();
    },
    async processAddons(products, productType) {
      const bouquetProductTags = this.product?.tags || [];
      const occasionsTag = this.occasion?.length
        ? this.generateOccasionTag(this.occasion)
        : "gift-adds";

      const deliveryWeekTag = this.selectWeekNumber(this.getDeliveryDate());
      const isRelevantOccasion = (tags) =>
        tags.includes(occasionsTag) || tags.includes("occasion:all");

      const processedAddons = products
        .filter((product) => {
          const { tags } = product;
          return (
            tags.includes("gift-adds") &&
            tags.includes("active") &&
            tags.includes(deliveryWeekTag) &&
            productType === GIFT_ADDS &&
            isRelevantOccasion(tags) &&
            !bouquetProductTags.includes(`hide:${product.title}`)
          );
        })
        .map((product) => {
          const variant = product.productVariants?.[0] || {};
          const salePrice = Number(variant.compareAtPriceV2?.amount || 0);
          const price = Number(variant.price?.amount || 0);

          return {
            src: this.getImages(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            id: variant.id,
            tags: product.tags,
            orderSequenceNumber: this.getOrderSequenceNumber(product.tags),
            sku: variant.sku,
            variant,
            title: product.title,
            titleView: this.getUserViewName(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            priceCompare: salePrice,
            price: salePrice > 0 ? salePrice : price,
            priceView: salePrice > 0 ? salePrice : price,
            salePrice: salePrice > 0 ? price : undefined,
            comparePriceView: salePrice,
            description: this.getUserViewDescription(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
          };
        });

      return this.splitAndSort(processedAddons);
    },
    async processVases(products, productType) {
      const bouquetProductTags = this.product?.tags || [];

      const occasionsTag = this.occasion?.length
        ? this.generateOccasionTag(this.occasion)
        : "vase";

      const deliveryWeekTag = this.selectWeekNumber(this.getDeliveryDate());
      const isOccasionRelevant = (tags) =>
        tags.includes(occasionsTag) || tags.includes("occasion:all");
      const isWeekRelevant = (tags) =>
        tags.includes(deliveryWeekTag) || tags.includes("vase-ongoing");
      const isWeekExcluded = (tags) => tags.includes(`not-${deliveryWeekTag}`);

      const processedVases = products
        .filter((product) => {
          const { tags } = product;
          return (
            tags.includes("vase") &&
            tags.includes("active") &&
            isOccasionRelevant(tags) &&
            isWeekRelevant(tags) &&
            !isWeekExcluded(tags) &&
            productType === VASE &&
            !bouquetProductTags.includes(`hide:${product.title}`)
          );
        })
        .map((product) => {
          const variant = product.productVariants?.[0] || {};
          const salePrice = Number(variant.compareAtPriceV2?.amount || 0);
          const price = Number(variant.price?.amount || 0);

          return {
            src: this.getImages(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            id: variant.id,
            tags: product.tags,
            sku: variant.sku,
            variant,
            title: product.title,
            titleView: this.getUserViewName(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            comparePriceView: salePrice,
            description: product.description,
            priceCompare: salePrice,
            price: salePrice > 0 ? salePrice : price,
            priceView: salePrice > 0 ? salePrice : price,
            salePrice: salePrice > 0 ? price : undefined,
          };
        });

      return this.splitAndSort(processedVases);
    },
    getImages(title, productType, cmsData) {
      const cmsProduct = cmsData.filter((product) =>
        product.productName.includes(title)
      )[0];
      return cmsProduct ? cmsProduct.image : "";
    },
    async loadAddons() {
      if (!this.disableSection) {
        try {
          const region = this.deliveryTown.regionShortCode.toLowerCase();
          let config = this.getConfig();
          await this.getAddonsContent();

          const promises = [];

          if (config.displayAddons) {
            const promise = this.getAddons(region);
            promises.push(promise);
            this.showAddons();
          }

          if (config.displayVases) {
            const promise = this.getVases(region);
            promises.push(promise);
            this.showVases();
          }

          // Use Promise.all to execute multiple API calls in parallel. which can reduce the overall execution time
          await Promise.all(promises);

          if (this.isObjectNotEmpty(this.$store.state.cartItem.vase)) {
            this.selectedVaseUpdated = [this.$store.state.cartItem.vase];
          }

          if (this.isObjectNotEmpty(this.$store.state.cartItem.addons)) {
            this.selectedAddonsUpdated = {
              ...this.$store.state.cartItem.addons,
            };
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    onAddonUpdate(addon) {
      addon["productType"] = GIFT_ADDS;
      if (addon.quantity === 0 || addon.quantity === "0") {
        this.$store.dispatch("cartItem/ADDON_REMOVE", addon);
      } else if (addon.quantity !== "") {
        this.$store.dispatch("cartItem/ADDON_UPDATE", addon);
      }
      this.$nuxt.$emit("addonUpdated", addon);
    },
    onVaseSelect(vase) {
      vase["productType"] = VASE;
      if (vase.quantity == 0) {
        this.$store.dispatch("cartItem/VASE_REMOVE", vase);
        this.selectedVaseUpdated = [];
      } else {
        this.$store.dispatch("cartItem/VASE_ADD", vase);
        this.selectedVaseUpdated = [{ ...vase }];
      }
      this.$nuxt.$emit("vaseUpdated", vase);
    },
    getPrice(price) {
      return this.getPriceWithLocale(price);
    },
    getConfig() {
      let productType = this.product.productType.key;
      if (productType.includes("Subscription")) {
        return this.configs["Subscription"];
      } else {
        return this.configs[productType];
      }
    },
  },
};
